import { render, staticRenderFns } from "./BookingPaymentModal.vue?vue&type=template&id=53fdd9c0"
import script from "./BookingPaymentModal.vue?vue&type=script&lang=js"
export * from "./BookingPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports